module.exports = __webpack_public_path__ + "media/images/icons/icon-color-picker-53b62b58adddaeea6645aa3c2901db31.svg";